// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import { SchemaForm, Input, Row, Col } from "@components";
import { uiSchema } from "./ui-schema";

type OwnProps = $Exact<{
  onRef: (ref: *) => void,
  data: Object,
  schema: Object,
  onChange: Function,
  onSubmit: Function,
  editing?: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class RtwCompliance extends React.Component<Props> {
  render() {
    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-8">
          {this.props.editing && this.props.data ? (
            <Row className="p-2">
              <Col className="d-flex flex-column flex-end">
                <label htmlFor="proccessId" className="mr-3">
                  {this.props.t("RETURN_TO_WORK_PROCESS_ID_VIEW")}:
                </label>
                <div className="w-100">
                  <Input id="proccessId" readOnly value={this.props.data.id} />
                </div>
              </Col>
            </Row>
          ) : null}
          {this.props.data ? (
            <SchemaForm
              ref={ref => this.props.onRef(ref)}
              className="w-100"
              formData={this.props.data}
              schema={this.props.schema}
              onChange={this.props.onChange}
              onSubmit={this.props.onSubmit}
              uiSchema={uiSchema(this.props.t)}
              externalSubmit
            >
              <div className="d-flex justify-content-center" />
            </SchemaForm>
          ) : null}
        </div>
      </div>
    );
  }
}

export default localize()(RtwCompliance);
